import React from 'react';
import PropTypes from 'prop-types';
import clamp from 'lodash/clamp';
import cn from 'classnames';
import PracticeSkillBox from 'chameleon-packages/units/components/PracticeSkillBox';

import './PracticeSkillsContainer.scss';

const PracticeSkillsContainer = React.forwardRef((props, ref) => {
  const {
    skills,
    onSetSkillCount,
    activeSkillIndex,
    ariaDescribedBy,
    setCount,
    columns,
    className,
  } = props;

  // Split Skill badges rows into maximum {columns}
  const containerClassName = cn(
    'PracticeSkillsContainer grid',
    {
      [`grid-cols-${clamp(skills.length, 1, columns)}`]: columns,
      'grid-flow-col': !columns,
    },
    className,
  );

  return (
    <div className={containerClassName}>
      {skills.map((skill, index) => (
        <PracticeSkillBox
          key={`practice-skill-box-${skill.label}`}
          label={skill.label}
          index={index}
          setCount={setCount}
          ariaDescribedBy={ariaDescribedBy[index]}
          onClick={onSetSkillCount}
          ref={index === 0 ? ref : null}
          activeRef={index === activeSkillIndex ? ref : null}
          isFocused={index === activeSkillIndex}
          ariaExpanded={index === activeSkillIndex}
          skillName={skill.name}
        />
      ))}
    </div>
  );
});

PracticeSkillsContainer.displayName = 'PracticeSkillsContainer';

PracticeSkillsContainer.propTypes = {
  /**
   * Skills to render
   * */
  skills: PropTypes.array.isRequired,
  /**
   * callback func to trigger a
   * */
  onSetSkillCount: PropTypes.func.isRequired,

  /**
   * The active skill index on the popover
   * */
  activeSkillIndex: PropTypes.number.isRequired,

  /**
   * Maximum number of columns skill could be spanned
   */
  columns: PropTypes.number,

  /**
   * Additional class name
   */
  className: PropTypes.string,
};

export default PracticeSkillsContainer;
